import { UnitsSystem } from '@App/app/entities/shared/units.model';
import { Component, Input } from '@angular/core';

/**
 * A labelled measurement row that renders an optional length value through the
 * shared optional-measurement-field. Shared by the measurement, tube and angle
 * iron property panels.
 */
@Component({
  selector: 'app-layer-details-length-row',
  templateUrl: './layer-details-length-row.component.html',
})
export class LayerDetailsLengthRowComponent {
  @Input() label: string;
  @Input() value?: number;
  @Input() unitsSystem: UnitsSystem;
  @Input() left = false;
}
